import {WindowParam} from "../../../../library/context/WindowContext";
import {ColumnUnit} from "../../../../library/atomic/unit/ColumnUnit";
import {SizeAttr} from "../../../../library/basic/size";
import {RowUnit} from "../../../../library/atomic/unit/RowUnit";
import {ColumnAttr, RowAttr} from "../../../../library/basic/compose";
import {SpanText} from "../../../../library/atomic/text/SpanText";
import {FontAttr} from "../../../../library/basic/font";
import {Button} from "antd";
import {getAccount} from "../../../util/account";

export type EntityType = "exchange_code" | "opinion" | "system_message"

export function getEntityName(entityType: EntityType): string {
    if (entityType == "exchange_code") return "兑换码"
    if (entityType == "opinion") return "意见反馈"
    if (entityType == "system_message") return "系统消息"
    return ""
}

export function getEntityList(): EntityType[] {
    return ["exchange_code", "opinion", "system_message"]
}

export function AdminNav(wp: WindowParam, currentPanel: string, setPanel: (newPanel: string) => void,
                         logout: () => void) {
    return (
        <ColumnUnit sizeAttr={new SizeAttr(wp, "100vw")}>
            {/*页面标题*/}
            <RowUnit
                sizeAttr={new SizeAttr(wp, "100vw", "36px")}
                customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                    "padding": "16px",
                })}
            >
                <SpanText
                    customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                        "marginRight": "0px"
                    })}
                    fontAttr={new FontAttr(wp, "1.5em", "600")}>
                    {"信风Flow运营管理系统"}
                </SpanText>

                <RowUnit
                    customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                        "marginLeft": "auto",
                        "marginRight": "32px"
                    })}
                >
                    <SpanText
                        customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                            "marginRight": "12px"
                        })}
                        fontAttr={new FontAttr(wp, "1em", "500")}>
                        {getAccount()}
                    </SpanText>
                    <Button
                        onClick={() => {
                            logout()
                        }}
                    >
                        {"退出登录"}
                    </Button>
                </RowUnit>
            </RowUnit>

            {/*管理选择*/}
            <RowUnit
                sizeAttr={new SizeAttr(wp, "100vw")}
                customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                    "paddingBottom": "16px",
                    "paddingLeft": "16px",
                    "paddingRight": "16px",
                    "borderBottom": "1px solid #dee2e6"
                })}
            >
                {
                    getEntityList().map((entity, idx) => {
                        return (
                            <Button
                                key={"AdminNav-entity-" + entity + "-" + idx}
                                style={{
                                    "marginRight": "16px"
                                }}
                                onClick={() => {
                                    if (currentPanel != entity) {
                                        setPanel(entity)
                                    }
                                }}>
                                {getEntityName(entity)}
                            </Button>
                        )
                    })
                }
            </RowUnit>
        </ColumnUnit>
    )
}